import React, { useRef } from "react";
import { Routes, Route } from "react-router-dom";
import RegistrationPages from "../pages/registrationPages/RegistrationPages";
import HeaderSection from "../pages/headerSection/HeaderSection";
import BannerPromoSection from "../pages/bannerPromoSection/BannerPromoSection";
import CategoryProductSection from "../pages/categorysection/CategoryProductSection";
import WhyLMSection from "../pages/whyLMSection/WhyLMSection";
import ShortCompanySection from "../pages/shortCompanySection/ShortCompanySection";
import FooterComponent from "../components/footer/Footer";
import CompanyPage from "../pages/companyPage/CompanyPage";
import CareerPage from "../pages/career/CareerPage";
import NewsEventPage from "../pages/newsEventPage/NewsEventPage";
import NewsDetailPage from "../pages/newsDetailPage/NewsDetailPage";
import NewsListEventPage from "../pages/newsEventPage/NewsListEventPage";
import RegistrationSudirmanPages from "../pages/registrationPages/RegistrationSudirmanPages";
import SMIPage from "../pages/smiPage/SmiPage";

const AppRoutes: React.FC = () => {
    const categoryRef = useRef<HTMLDivElement>(null); // Reference for CategorySection
    const footerRef = useRef<HTMLDivElement>(null);

    // Function to scroll to the BannerPromoSection
    const scrollToCategory = () => {
        categoryRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const scrollToFooter = () => {
        footerRef.current?.scrollIntoView({ behavior: "smooth"});
    }

    return (
        <div>

            {/* Main content: Use Routes here */}
            <main>
                <Routes>
                    {/* Default route (Home Page) */}
                    <Route
                        path="/"
                        element={
                            <>
                                {/* Pass the scrollToBanner function to HeaderSection */}
                                <HeaderSection onPaketClick={scrollToCategory} onContactClick={scrollToFooter} />
                                <BannerPromoSection />
                                <CategoryProductSection ref={categoryRef} />
                                <WhyLMSection />
                                {/* <ShortCompanySection /> */}
                                <NewsEventPage />
                                <FooterComponent ref={footerRef} />
                            </>
                        }
                    />
                    {/* Registration Page */}
                    <Route path="/register" element={<RegistrationPages />} />
                    {/* Company Page */}
                    <Route
                        path="/company"
                        element={
                            <>
                                <HeaderSection onPaketClick={scrollToCategory} onContactClick={scrollToFooter} />
                                <CompanyPage/>
                                <FooterComponent ref={footerRef} />
                            </>
                        } 
                    />
                    {/* Career Page */}
                    <Route path="/career"
                        element={
                            <>
                                <HeaderSection onPaketClick={scrollToCategory} onContactClick={scrollToFooter} />
                                <CareerPage />
                                <FooterComponent ref={footerRef} />
                            </>
                        }
                    />
                    {/* News Detail */}
                    <Route path="/detailnews"
                        element={
                            <>
                                <HeaderSection onPaketClick={scrollToCategory} onContactClick={scrollToFooter} />
                                <NewsDetailPage />
                                <FooterComponent ref={footerRef} />
                            </>
                        }
                    />
                    {/* News All Event */}
                    <Route path="/listnews"
                        element={
                            <>
                                <HeaderSection onPaketClick={scrollToCategory} onContactClick={scrollToFooter} />
                                <NewsListEventPage />
                                <FooterComponent ref={footerRef} />
                            </>
                        }
                    />
                    {/* Registration Sudirman Page */}
                    <Route path="/register-sudirman-park" element={<RegistrationSudirmanPages />} />
                    {/* SMI Policy Page */}
                    <Route
                        path="/smi"
                        element={
                            <>
                                <HeaderSection onPaketClick={scrollToCategory} onContactClick={scrollToFooter} />
                                <SMIPage/>
                                <FooterComponent ref={footerRef} />
                            </>
                        } 
                    />
                </Routes>
            </main>
        </div>
    );
};

export default AppRoutes;